import React from "react";
import {
    Calendar,
    Cast,
    Cloud,
    Cpu,
    FilePlus,
    Filter,
    GitCommit,
    Loader,
    MessageCircle,
    Send,
    ThumbsUp,
} from "react-feather";
import img_monitoramento from "../../imagens/mob_monitoramento.png";
import {CollCard, CollImg, ContainerBody, Wrapper} from "../styleMobile";
import {CardFeatures} from "../Components/CardFeatures";
import {CardHearder} from "../Components/CardHearde";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export const Monitoramento = ({id}) => {
    return (
        <ContainerBody id={id} background={'#5C9F7E'}>
            <Wrapper>
                <CardHearder
                    icon={<MessageCircle size={'40px'}/>}
                    titulo={'MONITORAMENTO'}
                    texto={'Nunca mais perca oportunidades! Monitore o Chat do Pregoeiro em ambiente organizado e inovador, receba alertas ou notificações por email sempre que for convocado pelo pregoeiro ou quando uma palavra-chave for citada. Acompanhe no Painel de Ocorrências do Dia as mensagens com ocorrência em Tempo Real!'}
                />

                <CollImg>
                    <div>
                        <img
                            src={img_monitoramento}
                            height={"auto"}
                            width={"100%"}
                            alt={"logo wavecode"}
                        />
                    </div>
                </CollImg>

                <CollCard>
                    <CardFeatures icon={<FilePlus/>} texto={"CADASTRO AUTOMÁTICO"}/>
                    <CardFeatures icon={<Cloud/>} texto={"MONITOR NAS NUVENS"}/>
                    <CardFeatures icon={<Calendar/>} texto={"OCORRÊNCIAS DO DIA"}/>
                    <CardFeatures icon={<Filter/>} texto={"5 TIPOS DE MONITORAMENTO"}/>
                </CollCard>

            </Wrapper>
        </ContainerBody>
    )
};
